import store from '@/store';



export function permission(router){

    // 需要过滤的参数
    // var filterOptions = [
    //     'sign'
    // ];
    
    // url白名单
    // var whiteList = [
    //     'city'
    // ];
    
    // getStore

    router.beforeEach((to, from, next) => {
        // 有登录信息进行存储，并删除url上参数
        var query = Object.assign({},to.query);
		//console.log(query['p']);
        if(query['p']){
			//console.log(query['s'],query['p']);
			store.commit('setPhone',query['p']);
			
			store.commit('setSign',query['s']);
			store.commit('setpaycard',query['paycard']);
			
			
			delete query['s'];
			delete query['p'];
			
			delete query['paycard'];
			if(query['cardNum'])
			{
				store.commit('setcardNum',query['cardNum']);
				delete query['cardNum'];
			}
			
		
     
            next({
                path:to.path,
                query: query
            })
        }



        next();
    })
	
	
}

